import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from './radix/Avatar';

interface ProfileHeaderProps {
  profileImageUrl?: string;
  userName?: string;
  totalPollsCreated?: number;
  linkTo?: string;
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  profileImageUrl,
  userName = 'User',
  totalPollsCreated,
  linkTo,
}) => {
  const getInitials = () => {
    const trimmed = userName.trim();
    if (!trimmed) return 'U';
    const parts = trimmed.split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return trimmed.slice(0, 2).toUpperCase();
  };

  const statsContent = `${totalPollsCreated} ${totalPollsCreated === 1 ? 'poll' : 'polls'} created`;

  return (
    <div className="user-profile-header">
      <Avatar
        src={profileImageUrl}
        fallback={getInitials()}
        className="profile-avatar"
      />
      <h2 className="user-name">{userName}</h2>
      {totalPollsCreated !== undefined ? (
        linkTo ? (
          <Link to={linkTo} className="user-stats">
            {statsContent}
          </Link>
        ) : (
          <div className="user-stats">
            {statsContent}
          </div>
        )
      ) : (
        <div className="user-stats skeleton">
          <span className="skeleton-bar"></span>
        </div>
      )}
    </div>
  );
};

